import { AlertTriangle, RotateCcw } from 'lucide-react'

interface FallbackNoticeProps {
  /** Nome do artefato, ex.: "Event Storm", "protótipo" */
  artifactName: string
  onRegenerate?: () => void
}

/**
 * Aviso de conteúdo provisório: o agente não conseguiu gerar o artefato a
 * partir das ideias e o backend entregou um esqueleto genérico (fallback).
 * Sem este aviso, o usuário acharia que o conteúdo é uma análise real.
 */
export default function FallbackNotice({ artifactName, onRegenerate }: FallbackNoticeProps) {
  return (
    <div
      role="status"
      className="flex items-center gap-2 px-4 py-2 bg-amber-50 dark:bg-amber-950/40 border-b border-amber-200 dark:border-amber-900 text-xs text-amber-800 dark:text-amber-200 shrink-0"
    >
      <AlertTriangle size={14} className="shrink-0 text-amber-500" aria-hidden="true" />
      <span className="flex-1 min-w-0">
        <strong>Conteúdo provisório:</strong> o agente não conseguiu gerar o {artifactName} a
        partir das suas ideias — este é um esqueleto genérico.
      </span>
      {onRegenerate && (
        <button
          type="button"
          onClick={onRegenerate}
          className="inline-flex items-center gap-1 px-2 py-1 rounded-md font-medium bg-amber-100 dark:bg-amber-900/50 hover:bg-amber-200 dark:hover:bg-amber-900 transition-colors focus:outline-none focus:ring-2 focus:ring-amber-500"
        >
          <RotateCcw size={11} aria-hidden="true" />
          Tentar novamente
        </button>
      )}
    </div>
  )
}
